module.exports = __webpack_public_path__ + "static/img/start_page.1fb6c2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/start_page.png
// module id = F+1/
// module chunks = 1